import axios from '../axiosHelper';
import Cookies from "js-cookie"

export default {
    state: {
        status: '',
        status_code: '',
        message: '',
        message_code: '',
        questionOverview : {},
        question : {},
        questionList : [{}],
        listSoal: [{}]
    },
    getters: {
        getQuestionOverview: state => state.questionOverview,
        getDetailQuestionOverview: state => state.question,
        getDetailQuestionlist: state => state.questionList,
        getListSoal: state => state.listSoal,
    },
    mutations: {
        request(state){
            state.status = 'LOADING'
        },
        success(state, { resp }){
            state.status = 'SUCCESS'
            if (resp) {
                state.status_code = resp.data.status
                state.message = resp.data.message
                state.message_code = resp.data.code
            }
        },
        error(state, { resp }){
            state.status = 'ERROR'
            if (resp) {
                state.status_code = resp.data.status
                state.message = resp.data.message
                state.message_code = resp.data.code
            }
        },
        setQuestionOverview(state, { resp }){
            if (resp) {
                state.questionOverview = resp.data.data
            }
        },
        setQuestion(state, { resp }){
            if (resp) {
                state.question = resp.data.data
            }
        },
        setDetailQuestionlist(state, { resp }){
            if (resp) {
                state.questionList = resp.data.data.list_soal
            }
        },
        setListSoal(state, { resp }){
            if (resp) {
                state.listSoal = resp.data.data.list_soal
            }
        }
    },
    actions: {
        getQuestionOverview({commit}, param){
            return new Promise(function (resolve, reject) {
                commit('request');
                axios({
                        url: '/v1/quiz/question/get-overview/'+param.quizId+'?token='+Cookies.get("token"),
                        method: 'GET'
                    })
                    .then(resp => {
                        commit('success', { resp })
                        commit('setQuestionOverview', { resp })
                        commit('setListSoal', { resp })
                        resolve(resp)
                    })
                    .catch(err => {
                        let resp = err.response
                        commit('error', { resp })
                        reject(err)
                    })
            })
        },
        addQuestion({commit}, form){
            return new Promise(function (resolve, reject) {
                commit('request');
                axios({
                        url: '/v1/quiz/question/add?token='+Cookies.get("token"),
                        data: form,
                        method: 'POST'
                    })
                    .then(resp => {
                        commit('success', { resp })
                        resolve(resp)
                    })
                    .catch(err => {
                        let resp = err.response
                        commit('error', { resp })
                        reject(err)
                    })
            })
        },
        updateQuestion({commit}, form){
            return new Promise(function (resolve, reject) {
                commit('request');
                axios({
                        url: '/v1/quiz/question/edit?token='+Cookies.get("token"),
                        data: form,
                        method: 'POST'
                    })
                    .then(resp => {
                        commit('success', { resp })
                        resolve(resp)
                    })
                    .catch(err => {
                        let resp = err.response
                        commit('error', { resp })
                        reject(err)
                    })
            })
        },
        deleteQuestion({commit}, form){
            return new Promise(function (resolve, reject) {
                commit('request');
                axios({
                        url: '/v1/quiz/question/delete?token='+Cookies.get("token"),
                        data: form,
                        method: 'POST'
                    })
                    .then(resp => {
                        commit('success', { resp })
                        resolve(resp)
                    })
                    .catch(err => {
                        let resp = err.response
                        commit('error', { resp })
                        reject(err)
                    })
            })
        },
        importQuestion({commit}, form){
            return new Promise(function (resolve, reject) {
                commit('request');
                axios({
                        url: '/v1/quiz/question/import-question?token='+Cookies.get("token"),
                        data: form,
                        method: 'POST',
                        headers: {
                            'content-type': 'multipart/form-data'
                        }
                    })
                    .then(resp => {
                        commit('success', { resp })
                        resolve(resp)
                    })
                    .catch(err => {
                        let resp = err.response
                        commit('error', { resp })
                        reject(err)
                    })
            })
        },
        importGraduation({commit}, form){
            return new Promise(function (resolve, reject) {
                commit('request');
                axios({
                        url: '/v1/student-progress/import-graduation?token='+Cookies.get("token"),
                        data: form,
                        method: 'POST',
                        headers: {
                            'content-type': 'multipart/form-data'
                        }
                    })
                    .then(resp => {
                        commit('success', { resp })
                        resolve(resp)
                    })
                    .catch(err => {
                        let resp = err.response
                        commit('error', { resp })
                        reject(err)
                    })
            })
        },
        getQuestion({commit}, param){
            return new Promise(function (resolve, reject) {
                commit('request');
                axios({
                        url: '/v1/quiz/question/get-question/'+param.quizId+'?token='+Cookies.get("token"),
                        method: 'GET'
                    })
                    .then(resp => {
                        commit('success', { resp })
                        commit('setQuestion', { resp })
                        commit('setDetailQuestionlist', { resp })
                        resolve(resp)
                    })
                    .catch(err => {
                        let resp = err.response
                        commit('error', { resp })
                        reject(err)
                    })
            })
        },
        submitQuestion({commit}, form){
            return new Promise(function (resolve, reject) {
                commit('request');
                axios({
                        url: '/v1/quiz/question/submit-question?token='+Cookies.get("token"),
                        data: form,
                        method: 'POST'
                    })
                    .then(resp => {
                        commit('success', { resp })
                        resolve(resp)
                    })
                    .catch(err => {
                        let resp = err.response
                        commit('error', { resp })
                        reject(err)
                    })
            })
        },
    }
}
